"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var eventNames = window.__BVD3_eventNames || (window.__BVD3_eventNames = new Set());
var listeners = window.__BVD3_listeners || (window.__BVD3_listeners = {});
var rpcReceivers = window.__BVD3_rpcReceivers || (window.__BVD3_rpcReceivers = {});
var Listener = /** @class */ (function () {
    function Listener(eventName, callback, id) {
        this.eventName = eventName;
        this.action = callback;
        if (typeof id === "string") {
            this.id = id;
        }
    }
    Listener.prototype.triggerCallback = function (data) {
        this.action.call(null, this.eventName, data);
    };
    return Listener;
}());
exports.Listener = Listener;
exports.on = function (eventName, callback, id) {
    if (!eventNames.has(eventName)) {
        addEventName(eventName);
    }
    listeners[eventName].push(new Listener(eventName, callback, id));
};
exports.emit = function (eventName, data) {
    if (!eventNames.has(eventName)) {
        return;
    }
    listeners[eventName].forEach(function (listener) {
        listener.triggerCallback(data);
    });
};
exports.remove = function (eventName, id) {
    if (!eventNames.has(eventName)) {
        return;
    }
    if (typeof id === "string") {
        _.remove(listeners[eventName], function (x) { return x.id === id; });
    }
    else {
        listeners[eventName] = [];
    }
};
// rpc
function rpcRegisterReceiver(label, callback) {
    rpcReceivers[label] = callback;
}
exports.rpcRegisterReceiver = rpcRegisterReceiver;
function rpc(label, data) {
    if (!rpcReceivers[label]) {
        return undefined;
    }
    return rpcReceivers[label].call(null, data);
}
exports.rpc = rpc;
exports.CANVAS_READY = "canvas-ready";
exports.CANVAS_MOUNTED = "canvas-mounted";
exports.CANVAS_INITIALIZED = "canvas-initialized";
exports.DATA_LOADING_STARTED = "data-loading-started";
exports.DATA_LOADING_FINISHED = "data-loading-finished";
exports.DATA_LOADING_FAILED = "data-loading-failed";
exports.EDITOR_READY = "editor-ready";
exports.BEFORE_DRAW = "will-draw";
exports.AFTER_DRAW = "did-draw";
var addEventName = function (name) {
    eventNames.add(name);
    listeners[name] = [];
};
//# sourceMappingURL=event.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/event.js
// module id = 86
// module chunks = 0 1